/**
 * Custom Collection Page section
 * ---------------------------------------------------------------------------
 * Extracted from sections/custom-collection-page.liquid, where it was inline <script>.
 * Inline scripts are parser-blocking, uncacheable, and re-sent on every page
 * view. This asset is deferred and cached, and initialises every instance on
 * the page instead of binding to a single section id.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="custom-collection-page"]';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.customcollectionpageInit === 'true') return;
    sectionEl.dataset.customcollectionpageInit = 'true';

    var sectionId = sectionEl.dataset.sectionId;
    // 1. TOP 10 CAROUSEL
    const topTenTrack = sectionEl.querySelector('#TopTenTrack-' + sectionId);
    const prevBtn = sectionEl.querySelector('.top-ten__arrow--prev');
    const nextBtn = sectionEl.querySelector('.top-ten__arrow--next');

    if (topTenTrack && prevBtn && nextBtn) {
      function getScrollStep() {
        const slide = topTenTrack.querySelector('.top-ten__slide');
        return slide ? (slide.offsetWidth + 16) * 2 : 400;
      }
      prevBtn.addEventListener('click', function () {
        topTenTrack.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        topTenTrack.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    // 2. FILTER ACCORDIONS
    const filterTriggers = sectionEl.querySelectorAll('.filter-group__trigger');
    filterTriggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
        const group = trigger.closest('.filter-group');
        if (group) {
          const isExp = group.classList.contains('is-expanded');
          group.classList.toggle('is-expanded');
          trigger.setAttribute('aria-expanded', !isExp);
        }
      });
    });

    // 3. SORTING & MOBILE SHEETS
    const grid = sectionEl.querySelector('#CollectionGrid-' + sectionId);
    const sortRadios = sectionEl.querySelectorAll('input[name="collection_sort"]');
    const mobileSortRadios = sectionEl.querySelectorAll('input[name="mobile_sheet_sort"]');
    const clearAllBtn = sectionEl.querySelector('#FilterClearAll-' + sectionId);
    const sidebar = sectionEl.querySelector('#CollectionSidebar-' + sectionId);
    const filterBackdrop = sectionEl.querySelector('#MobileFilterBackdrop-' + sectionId);
    const mobileFilterBtn = sectionEl.querySelector('#MobileFilterBtn-' + sectionId);
    const mobileFilterCloseBtn = sectionEl.querySelector('#MobileFilterCloseBtn-' + sectionId);
    const mobileFilterApplyBtn = sectionEl.querySelector('#MobileFilterApplyBtn-' + sectionId);

    const sortDrawer = sectionEl.querySelector('#MobileSortDrawer-' + sectionId);
    const sortBackdrop = sectionEl.querySelector('#MobileSortBackdrop-' + sectionId);
    const mobileSortBtn = sectionEl.querySelector('#MobileSortBtn-' + sectionId);
    const mobileSortCloseBtn = sectionEl.querySelector('#MobileSortCloseBtn-' + sectionId);

    const activeTagsContainer = sectionEl.querySelector('#MobileActiveTags-' + sectionId);

    function sortProducts(sortBy) {
      if (!grid) return;
      const items = Array.from(grid.querySelectorAll('.collection-grid__item'));
      items.sort((a, b) => {
        const priceA = parseFloat(a.getAttribute('data-price') || 0);
        const priceB = parseFloat(b.getAttribute('data-price') || 0);
        const indexA = parseInt(a.getAttribute('data-product-index') || 0, 10);
        const indexB = parseInt(b.getAttribute('data-product-index') || 0, 10);

        if (sortBy === 'price-ascending') return priceA - priceB;
        if (sortBy === 'price-descending') return priceB - priceA;
        if (sortBy === 'newest') return indexB - indexA;
        return indexA - indexB;
      });

      items.forEach(item => grid.appendChild(item));
    }

    // Sync Sorts
    sortRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          sortProducts(radio.value);
          const mobRadio = sectionEl.querySelector('input[name="mobile_sheet_sort"][value="' + radio.value + '"]');
          if (mobRadio) mobRadio.checked = true;
        }
      });
    });

    mobileSortRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          sortProducts(radio.value);
          const deskRadio = sectionEl.querySelector('input[name="collection_sort"][value="' + radio.value + '"]');
          if (deskRadio) deskRadio.checked = true;
          setTimeout(() => {
            if (sortDrawer) sortDrawer.classList.remove('is-open');
            document.body.style.overflow = '';
          }, 180);
        }
      });
    });

    // Reset drawers on initialization/refresh
    closeMobileFilter();
    closeMobileSort();

    // Mobile Drawer Open / Close
    if (mobileFilterBtn && sidebar) {
      mobileFilterBtn.addEventListener('click', function () {
        sidebar.classList.add('is-mobile-open');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeMobileFilter() {
      if (sidebar) sidebar.classList.remove('is-mobile-open');
      document.body.style.overflow = '';
    }

    if (mobileFilterCloseBtn) mobileFilterCloseBtn.addEventListener('click', closeMobileFilter);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeMobileFilter);
    if (mobileFilterApplyBtn) mobileFilterApplyBtn.addEventListener('click', closeMobileFilter);

    // Mobile Sort Open / Close
    if (mobileSortBtn && sortDrawer) {
      mobileSortBtn.addEventListener('click', function () {
        sortDrawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeMobileSort() {
      if (sortDrawer) sortDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (mobileSortCloseBtn) mobileSortCloseBtn.addEventListener('click', closeMobileSort);
    if (sortBackdrop) sortBackdrop.addEventListener('click', closeMobileSort);

    // Active Tags Rendering (e.g. M ✕)
    function updateActiveTags() {
      if (!activeTagsContainer) return;
      activeTagsContainer.innerHTML = '';
      const checkedInputs = sectionEl.querySelectorAll('.filter-checkbox-input:checked, .filter-size-input:checked, .filter-color-input:checked');
      
      checkedInputs.forEach(input => {
        let labelText = input.value.toUpperCase();
        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'filter-active-pill';
        pill.innerHTML = `<span>${labelText}</span> <span class="filter-active-pill__x">✕</span>`;
        pill.addEventListener('click', function () {
          input.checked = false;
          input.dispatchEvent(new Event('change'));
          updateActiveTags();
        });
        activeTagsContainer.appendChild(pill);
      });
    }

    sectionEl.querySelectorAll('.filter-checkbox-input, .filter-size-input, .filter-color-input').forEach(input => {
      input.addEventListener('change', updateActiveTags);
    });

    // Native filter form: apply on change, no submit button needed.
    const filterForm = sectionEl.querySelector('#CollectionFilterForm-' + sectionId);
    if (filterForm) {
      filterForm.addEventListener('change', function (e) {
        if (e.target.matches('.filter-checkbox-input, .filter-size-input, .filter-color-input')) {
          filterForm.submit();
        }
      });
      // Price inputs shouldn't submit on every keystroke.
      filterForm.querySelectorAll('.filter-price-input').forEach(input => {
        input.addEventListener('change', () => filterForm.submit());
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            filterForm.submit();
          }
        });
      });
    }

    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        // With native filters active, clearing means reloading the collection
        // without any filter parameters.
        if (filterForm) {
          window.location.href = filterForm.getAttribute('action') || window.location.pathname;
          return;
        }
        sectionEl.querySelectorAll('.filter-checkbox-input, .filter-size-input, .filter-color-input').forEach(cb => cb.checked = false);
        sectionEl.querySelectorAll('.filter-price-input').forEach(inp => inp.value = '');
        const relevancyRadio = sectionEl.querySelector('input[value="relevancy"]');
        if (relevancyRadio) {
          relevancyRadio.checked = true;
          sortProducts('relevancy');
        }
        const mobileRelevancyRadio = sectionEl.querySelector('input[name="mobile_sheet_sort"][value="relevancy"]');
        if (mobileRelevancyRadio) mobileRelevancyRadio.checked = true;
        updateActiveTags();
      });
    }

    // 4. LOAD MORE
    const loadMoreBtn = sectionEl.querySelector('#LoadMoreBtn-' + sectionId);
    const paginationWrap = sectionEl.querySelector('#CollectionPagination-' + sectionId);

    if (loadMoreBtn && grid && paginationWrap) {
      const totalItems = grid.querySelectorAll('.collection-grid__item').length;
      const visibleCountSpan = paginationWrap.querySelector('.collection-pagination__visible-count');
      const totalCountSpan = paginationWrap.querySelector('.collection-pagination__total-count');
      const fillBar = paginationWrap.querySelector('.collection-pagination__bar-fill');

      if (totalCountSpan) totalCountSpan.textContent = totalItems;

      function updateProgress() {
        const currentVisible = grid.querySelectorAll('.collection-grid__item:not(.is-hidden-product)').length;
        if (visibleCountSpan) visibleCountSpan.textContent = currentVisible;
        if (fillBar && totalItems > 0) {
          fillBar.style.width = Math.min(100, Math.round((currentVisible / totalItems) * 100)) + '%';
        }
        if (currentVisible >= totalItems) {
          loadMoreBtn.style.display = 'none';
        }
      }

      updateProgress();

      loadMoreBtn.addEventListener('click', function () {
        loadMoreBtn.classList.add('is-loading');

        setTimeout(() => {
          const hiddenItems = Array.from(grid.querySelectorAll('.collection-grid__item.is-hidden-product'));
          hiddenItems.slice(0, 8).forEach(item => item.classList.remove('is-hidden-product'));
          loadMoreBtn.classList.remove('is-loading');
          updateProgress();
        }, 400);
      });
    }

    // 5. WISHLIST
    // 5. SIZE CHART QUICK ADD TO CART
    sectionEl.addEventListener('click', async function (e) {
      const btn = e.target.closest('.custom-collection__size-box');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.disabled || btn.classList.contains('is-soldout') || btn.classList.contains('is-loading')) {
        return;
      }

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        const card = btn.closest('.collection-product-card');
        const link = card ? card.querySelector('.collection-product-card__link') : null;
        if (link) window.location.href = link.href;
        return;
      }

      btn.classList.add('is-loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1
          })
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          btn.classList.remove('is-loading');
          alert(errData.description || errData.message || 'Unable to add this item to cart.');
          return;
        }

        const addedItem = await response.json();
        const cartResponse = await fetch('/cart.js');
        const fullCart = await cartResponse.json();

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(() => {
          btn.classList.remove('is-added');
        }, 1200);

        const newCount = fullCart.item_count;
        const cartBubbles = document.querySelectorAll('.custom-header__cart-bubble, [data-cart-count]');
        cartBubbles.forEach(bubble => {
          bubble.textContent = newCount;
          if (newCount > 0) {
            bubble.classList.add('is-visible');
            bubble.classList.remove('has-pulse');
            void bubble.offsetWidth;
            bubble.classList.add('has-pulse');
          } else {
            bubble.classList.remove('is-visible');
          }
        });

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: fullCart } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: addedItem, cart: fullCart } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: fullCart } }));
        document.dispatchEvent(new CustomEvent('cart:open'));
      } catch (error) {
        btn.classList.remove('is-loading');
        console.error('Error adding size to cart:', error);
        const card = btn.closest('.collection-product-card');
        const link = card ? card.querySelector('.collection-product-card__link') : null;
        if (link) window.location.href = link.href + '?variant=' + variantId;
      }
    });

    // 6. SYNC STICKY POSITION WITH HEADER (DESKTOP ONLY)
    function updateSidebarStickyTop() {
      const sidebar = sectionEl.querySelector('.collection-sidebar');
      if (!sidebar) return;
      if (window.innerWidth <= 900) {
        sidebar.style.top = '';
        sidebar.style.maxHeight = '';
        return;
      }
      const header = document.querySelector('.custom-header-wrapper, .ch-sticky-active, .site-header, header');
      let headerOffset = 20;
      if (header) {
        const style = window.getComputedStyle(header);
        if (style.position === 'fixed' || style.position === 'sticky') {
          const rect = header.getBoundingClientRect();
          if (rect.bottom > 0) {
            headerOffset = Math.round(rect.bottom) + 16;
          }
        }
      }
      sidebar.style.top = headerOffset + 'px';
      sidebar.style.maxHeight = 'calc(100vh - ' + (headerOffset + 24) + 'px)';
    }

    // updateSidebarStickyTop reads getComputedStyle + getBoundingClientRect and
    // then writes sidebar.style.top - a layout read followed by a layout
    // invalidation. Bound directly to scroll it ran on every scroll event and
    // thrashed layout the whole way down the page. Throttled to one run per
    // frame, which is the most often it can produce a visible change anyway.
    let stickyTick = false;
    function onScrollSticky() {
      if (stickyTick) return;
      stickyTick = true;
      requestAnimationFrame(function () {
        stickyTick = false;
        updateSidebarStickyTop();
      });
    }

    window.addEventListener('scroll', onScrollSticky, { passive: true });
    window.addEventListener('resize', onScrollSticky);
    updateSidebarStickyTop();
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
